/* eslint-disable no-unused-vars */
import { Alert, Box, Text } from '@chakra-ui/react';
import {
  useAccess,
  useCancelServiceWithdraw,
  useVerifyServiceWithdraw,
} from 'hooks';
import { useTranslation } from 'localization';

import { Button } from 'components';

type FormProps = {
  onAction: ({
    status,
    redirectUrl,
  }: {
    status: 'success' | 'cancel';
    redirectUrl: string;
  }) => void;
  transactionId: string;
};

const Form: React.FC<FormProps> = ({ onAction, transactionId }: FormProps) => {
  const { t } = useTranslation('component.services.xm.deposit.form');
  const access = useAccess();

  const { mutateAsync: submit, isPending: submitLoading } =
    useVerifyServiceWithdraw();
  const { mutateAsync: cancel, isPending: cancelLoading } =
    useCancelServiceWithdraw();

  const onSubmit = async () => {
    if (access.verifyWithdrawExternalServicePermission) {
      submit({ id: transactionId }).then((res) => {
        onAction({ status: 'success', redirectUrl: res.redirect_url });
      });
    }
  };

  const cancelTransaction = () => {
    if (access.rejectWithdrawExternalServicePermission) {
      cancel({ id: transactionId }).then((res) => {
        onAction({ status: 'cancel', redirectUrl: res.redirect_url });
      });
    }
  };

  return (
    <Box pt={8}>
      <Alert.Root status="warning" mt={10}>
        <Text color="orange" textAlign="center">
          {t('hint')}
        </Text>
      </Alert.Root>
      <Box
        w="full"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={4}
      >
        <Button
          w="50%"
          type="submit"
          onClick={() => onSubmit()}
          variant="filled"
          isLoading={submitLoading}
          title={t('submit')}
          mt={8}
        />
        <Button
          w="50%"
          variant="ghost"
          title={t('cancel')}
          mt={8}
          isLoading={cancelLoading}
          onClick={() => cancelTransaction()}
        />
      </Box>
    </Box>
  );
};
export default Form;
